export default {
  /** strings for accessibility features (i.e. VoiceOver) */
  accessibility: {
    types: {
      button: 'button',
      header: 'header',
    },

    refresh: 'Aktualisierung',
    refreshHint:
      'Holen Sie sich den Fragebogen und den Status neu.Die aktuelle Seite wird aktualisiert.',

    back: 'zurück',
    backHint: 'Springt zur vorherigen Seite.',

    close: 'nah dran',
    closeHint: 'Schließt die aktuelle Seite oder Modal.',

    accept: 'annehmen',
    cancel: 'Abbrechen',
    acceptHint:
      'Wechselt in die Standard-Browser-Anwendung und öffnet dort Link.',

    menu: 'Weitere Informationen',
    menuHint: 'Öffnet neue Seite mit zusätzlichen Informationen und Links.',

    logoutHint: 'Startet den Abmeldeprozess und umleiten die Anmeldeseite.',
    loginHint: 'Startet Anmeldevorgang und leitet den QR-Code-Scanner um.',

    questionnaire: {
      middleButtonFinished: 'Nächste Frage. Frage wird beantwortet.',
      middleButtonUnfinished:
        'Nächste Frage, obwohl die Frage noch nicht beantwortet wird.',
      middleButtonHint:
        'Springt zu den nächsten Fragen oder schließt das Modal, wenn dies die letzte Frage war.',

      rightButtonHint: 'Springt zur nächsten Frage.',
      leftButtonHint: 'Springt zur vorherigen Frage.',
      alertButtonHint: 'Schließt den Alarm.',

      questionnaireCellHint:
        'Öffnet neue Seite, um die Kategorien der Fragebogen anzuzeigen.',
      categoryCellHint:
        'Öffnet MODAL, um diesen Fragebogeneintrag auszufüllen.',
      category: 'Diese Kategorie',
      questionnaire: 'Dieser Fragebogen',
      notStarted: 'wurde noch nicht beantwortet.',
      notFinished:
        'wurde bereits gestartet, ist aber noch nicht vollständig ausgefüllt.',
      finished: 'ist vollständig vollständig.',

      sendHint: 'Sendet den Fragebogen an die Bewertung.',

      multipleChoice:
        '(Mehrfachauswahl möglich)',
      singleChoice:
        'Einzelne Wahl - Nur eine Antwort-Option kann ausgewählt werden.',
      textFieldHint:
        'Bitte füllen Sie hier die angeforderten Informationen aus.',
      dateFieldHint: 'Öffnet ein neues Modal, um ein Datum auszuwählen.',
      sliderFieldEquals: 'entspricht',
      sliderFieldAnd: ', und',

      triggerHint:
        'Wenn dieses Element ausgewählt ist, wird eine weitere zusätzliche Frage angezeigt, die mit diesem Element verbunden ist.Bitte füllen Sie auch die zusätzliche Frage aus.',
      expandCategory: 'Fragen dieser Kategorie anzeigen',
      collapseCategory: 'Fragen dieser Kategorie ausblenden',

      requiredNotAnswered: 'Sie haben diese Frage noch nicht beantwortet. Bitte beantworten Sie die Frage um fortzufahren.',
      warningNotAnswered: 'Sie haben diese Frage noch nicht beantwortet. Sind Sie sicher, dass Sie zur nächsten Frage übergehen möchten?',
      warningNotAnsweredTitle: 'Keine Antwort gegeben',
      warningAnswerNow: 'Jetzt beantworten',
      warningSkip: 'Frage überspringen',
      continueFromLastTitle: 'Fortfahren',
      continueFromLast: 'Sie haben zuletzt mit der Beantwortung der Fragen abgebrochen. Möchten Sie mit der Frage fortfahren, bei der Sie zuletzt stehen geblieben sind?',
      continueFromLastYes: 'Jetzt fortfahren',
      continueFromLastNo: 'Abbrechen',
    },
  },

  /** contains all string rendered on the login-screen, as well as the ones for the landing-screen */
  maintenance: {
    title: 'Wir sind bald wieder für Sie da',
    description: 'Wir führen derzeit Wartungsarbeiten am Umfragetool ACRIBiS durch.',
    body: 'Während dieser Zeit ist die App vorübergehend nicht verfügbar. Wir bitten um Ihr Verständnis.',
    recovery: 'Sie können diese Seite geöffnet lassen. Sobald die Wartung abgeschlossen ist, wird die App automatisch wieder angezeigt.',
    moreInformation: 'Weitere Informationen',
    thanks: 'Vielen Dank für Ihre Geduld.',
  },

  login: {
    title: 'Anmeldung',
    subTitle: '',
    submit: 'Anmeldung',
    user: 'Subjekt-ID.',
    pass: 'Passwort',
    waiting: 'Meldet an...',
    btnLogin: 'Anmelden',
    errorPass: 'Bitte versuche es erneut.',
    noSubjectId: 'Kein gültiges SubjektD gefunden',
    errorUserUnauthorized: 'Ungültige Benutzerdaten.',
    qrInfo: 'Bitte zeigen Sie nun die Kamera auf den QR-Code den Sie von Ihrer Studienleitung zur Anmeldung in der App bekommen haben.',
    errorUserGeneric: 'Bei der Anmeldung trat ein Problem auf.',
    permissionCameraTitle: 'Kamera-Zugriff erforderlich',
    permissionCameraExplanation:
        'Wir brauchen Ihre Erlaubnis für den Zugriff auf die Smartphone-Kamera, um den Zugangs-QR-Code einfach einzuscannen.',
    permissionCameraAlternativeExplanation: 'Alternativ, können Sie Ihre Zugangs-ID in das Eingabefeld eingeben. Tippen Sie anschließend den "Anmelden"-Button.',
    permissionCameraGrant: 'Zugriffserlaubnis für Kamera erteilen',
    nextStepAfterError: 'Bitte versuchen Sie es später erneut anzumelden.',
    enterStudyId: 'Eingabe Zugangscode',
    enterAccessCode: 'Bitte geben Sie Ihren Zugangscode in das Eingabefeld ein.\nBetätigen Sie anschließend den "Anmelden"-Button.',
    enterAccessCodeAlternative: 'Alternativ können Sie auch den Zugangs-QR-Code mit Ihrer Webcam einscannen, falls Sie einen QR-Code von uns erhalten haben und Ihr Rechner über eine Kamera verfügt:',
    noCamAvailable:' 🎥 Kein Zugriff auf Webcam-Stream möglich (bitte stellen Sie sicher, dass\nSie eine aktivierte Webcam haben).',
    noQRCodeRecognized: 'Kein QR-Code erkannt',

    /** contains all strings of the landing-screen */
    landing: {
      buttonText: 'Navigieren Sie zum Anmeldebildschirm',
      title: '',
      subTitle: '',
      welcomeTitle: 'Willkommen beim Umfragetool ACRIBiS',
      text: 'Sie haben von der Studienleitung für die Studie in der Sie teilnehmen einen QR-Code zur Anmeldung in der App erhalten. Bitte melden Sie sich nun mit dem erhaltenen QR-Code in der App an.',
      autoLoginErrorTitle: 'Auto-Anmeldung fehlgeschlagen',
      autoLoginError:
        'Beim Versuch, sich automatisch anzumelden, ist ein Fehler aufgetreten.Bitte überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut',
      retry: 'wiederholen',
      deleteAll: 'Alle lokal gespeicherten Daten löschen'
    },
  },

  walkthrough: {
    k1: {
      title: 'Willkommen beim Umfragetool ACRIBiS',
      text: 'Mit der Teilnahme an der Studie haben Sie der Beantwortung eines oder mehrerer Fragebögen zugestimmt. \n\n' +
          'Nach erfolgreicher Anmeldung beim Umfragetool finden Sie auf der Startseite eine Übersicht über die für Sie verfügbaren Fragebögen. ',
    },
    k2: {
      title: 'Beantworten eines Fragebogens',
      text: 'Bei der Beantwortung des Fragebogens muss jede Angabe über den „Weiter“-Button bestätigt werden. \n\n' +
          'Die Beantwortung eines Fragebogens kann jederzeit pausiert und zu einem späteren Zeitpunkt fortgesetzt werden. Die gegebenen Antworten werden auf dem Gerät gespeichert. Darüber hinaus werden bereits beantwortete Fragen farblich (blau) gekennzeichnet. ',
    },
    k3: {
      title: 'Absenden eines Fragebögen',
      text: 'Ein Fragebogen enthält unter anderem sogenannte „Pflichtfragen“, die als solche gekennzeichnet sind. Ein Fragebogen kann grundsätzlich nur abgeschickt werden, wenn jede dieser Pflichtfragen beantwortet wurden. Nach dem Absenden des Fragebogens können die ausgewählten oder angegebenen Antworten nicht mehr verändert werden. ',
    },
    k4: {
      title: 'Verfügbare Fragebögen',
      text: 'Beachten Sie, dass im Laufe der Studie gegebenenfalls weitere Fragebögen für Sie zum Ausfüllen bereitgestellt werden. In diesem Fall werden Sie durch eine Benachrichtigung informiert. \n\n' +
          'Aufgrund dessen bitten wir Sie darum, sich erst nach Beendigung der Studie von der App abzumelden beziehungsweise diese zu deinstallieren. ',
    }
  },

  /** strings with generic purpose that can be used throughout the application */
  generic: {
    questionnaire: 'Fragebogen',
    mandatoryQuestion: 'Pflichtfrage',
    no: 'Nein',
    yes: 'Ja',
    ok: 'OK',
    choose: 'Auswählen',
    continue: 'Weiter',
    back: 'Zurück',
    submit: 'Abschicken',
    confirm: 'Bestätigen',
    save: 'Speichern',
    wait: 'Bitte warten...',
    remainingTime: 'Verbleibende Zeit',
    minutesShort: 'Min.',
    page: 'Seite',
    error: 'Fehler',
    abort: 'Abbrechen',
    warning: 'Warnung',
    info: 'Information',
    errorTitle: 'Fehler',
    successTitle: 'Erfolg',
    delete: 'Ja, Daten löschen',
    goBack: 'Ja, bitte melden Sie sich an',
    logoutWarning: 'Abmeldung Warnung',
    sendSuccess: 'Ihre Antworten wurden erfolgreich abgeschickt.',
    sendError:
      'Bei der Datenübermittlung ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es zu einem späteren Zeitpunkt erneut oder kontaktieren Sie den Administrator.',
    sendErrorTwoDevices:
      'Sie haben diesen Fragebogen bereits durch die App an einem anderen Gerät gesendet.',
    eraseAllWarning:
      'Dadurch werden alle auf Ihrem Gerät gespeicherten Daten gelöscht und Sie werden abgemeldet. Möchten Sie fortfahren?',
    eraseLocalDataAtEndOfStudyText:
      'Dies wird die Studie beenden. Sobald der Benutzer die lokalen Daten bestätigt hat, wird der Teilnehmer abgemeldet. Möchten Sie fortfahren?',
    eraseLocalDataAtEndOfStudyTitle: 'Lokal gespeicherte Daten löschen und abmelden',
    wrongLanguageVersionDetected:
      'Der aktuelle Fragebogen stimmt nicht mit der aktuell ausgewählten Sprache auf Ihrem Gerät überein. Dieser Fragebogen wird nun durch eine passende Version ersetzt. Ihre Antworten gehen dabei verloren.',
    updateError:
      'Beim Erhalten der angeforderten Daten ist ein Fehler aufgetreten - bitte prüfen Sie Ihre Daten und versuchen Sie es erneut.',
    infoRemoval:
      'Der derzeit aktuelle Fragebogen ist veraltet und wird nun entfernt.',
    reportWhileInIteratedMode:
      'Dialog, um dem Benutzer mitzuteilen, dass er bereits in einem speziellen Bericht gesendet wurde und dass er gerade in einem speziellen Intervall ist.',
    reportWhileQuestionnaire:
      'Dialog, um dem Benutzer mitzuteilen, dass derzeit ein Fragebogen zur Verfügung steht und dass er das verwenden könnte, um über seinen Zustand zu berichten.',
    errorNoInternetTitle: 'Keine aktive Internetverbindung gefunden.',
    errorNoInternet: 'Bitte aktivieren Sie Ihre Internetverbindung, sorgen Sie für eine gute Signalstärke und versuchen Sie es erneut.',
    allowNotificationsTitle: 'Benachrichtigungen erlauben',
    allowNotificationsExplanation: 'Wir möchten Ihnen gerne Benachrichtigungen schicken, um Sie auf bevorstehende Fragebögen und anstehende Ereignisse im Laufe der Studie an der Sie teilnehmen erinnern.\n\nBitte erlauben Sie in den nächsten Schritten das Setzen von Weckern und Erinnerungen, sowie von Benachrichtigungen.',
    notificationsTitle: 'Benachrichtigungen',
    studyId: 'Probanden-ID',
    skip: 'Überspringen',
    done: 'Fertig',
    progress: 'Fortschritt',
    close: 'Schließen',
  },

  /** strings of the about-screen */
  about: {
    title: 'Über',
    subTitle: 'Über das Umfragetool ACRIBiS',
    logout: 'Abmelden',
    delete: 'Meine Daten löschen und Abmelden',
    demoDelete: 'Alles löschen & Abmelden (nur für diese Demo)',
    languageSelection: 'Sprachauswahl',
    languageWarning:
      'Bei Änderung der Sprachauswahl werden Ihre bisher eingegebenen Daten vom Gerät gelöscht.',
    languageWarningAddition: '\nWillst du fortfahren?',
    allRightsReserved: 'Alle Rechte vorbehalten',
    devNotice: 'App-Entwicklung: Institut für Digitale Medizin, Universitätsklinikum Bonn (UKB)',

    /** contains the strings for the optional LegalInformation Screen */
    legal: {
      title: 'Datenschutzerklärung',
      subTitle:
          'Wie wir Ihre Daten behandeln',
      iconType: 'entypo',
      iconTitle: 'suitcase',
    },
    intro: {
      title: 'Einführung',
      subTitle:
          'Kurze Einführung in die App anzeigen',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },
    bleDevices: {
      title: 'BLE Geräte',
      subTitle:
          'Unterstützte Geräte koppeln',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },
    notifications: {
      title: 'Benachrichtigungen',
      subTitle:
          'Benachrichtigungen von der App als Erinnerung zu bevorstehenden Ereignissen erhalten',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },
  },

  filePicker: {
    chooseFile: "Datei zum Hochladen auswählen",
    dragAndDrop: "Dateien hierher ziehen und ablegen oder auf \"Datei zum Hochladen auswählen\" klicken",
    dropFilesHere: "Dateien hier ablegen...",
    uploadFiles: "Ausgewählte Dateien hochladen"
  },

  /** contains the strings for the legal information screen */
  legalInformation: {
    title: 'Nutzungsbedingungen',
    subTitle: '',

    content:
      'Nutzungsbedingungen'
  },

  /** strings of the survey-screen */
  survey: {
    subTitle: 'test',
    logout: 'Abmelden',
    subTitleCheckIn: '',
    title: 'Fragebögen',
    isLoading: 'Wird geladen...',
    yourAnswer: 'Ihre Antwort',
    titleCheckIn: 'Umfragetool ACRIBiS',
    welcomeTitle: 'Willkommen',
    noUserTitle: 'Benutzer wurde nicht gefunden',
    sendFinished: 'Antworten abschicken',
    send: 'Fragebogen abschicken',
    additionalAnswer: 'zusätzlicheAntwort',
    alternativeAnswer: 'alternativeAntwort',
    surveySubTitle: 'Bitte ausfüllen bis zum: ',
    surveyTitle: 'Fragebögen ausfüllen',
    inputPlaceholder: 'Bitte gib deine Antwort ein',
    endedStudyTitle: 'Ende des Teilnahme-Titels',
    noQuestionnaireTitle: 'Fragebogen nicht gefunden',
    loadingQuestionnaire: 'Anfragen \n Questionnaire.',
    inputPlaceholderTime: 'Bitte geben Sie das Datum hier ein',
    sessionTimeout: 'Ihr Benutzer konnte nicht erkannt werden',
    reloadingQuestionnaire: 'Wiederverladung \n Questionnaire',
    welcomeTitleFirstTime: 'Studienteilnahme',
    surveyTitleFirstTime: 'Ihr Einstiegs-Fragebogen-Titel',
    noUserText:
      'Ihre ID konnte nicht überprüft werden.Bitte versuche es erneut.',
    welcomeTextFirstTimeUser2:
      '- Dies ist der zweite Teil dieser Nachricht.',
    sendFinishedMessage:
      'Bitte bestätigen Sie, dass Sie die Antworten nun abschicken möchten.',
    noNewQuestionnaireAvailableYetTitle:
      'Titel, falls kein Fragebogen verfügbar ist',
    sendUnfinishedMessageDenied:
      'Der aktuelle Fragebogen ist noch nicht abgeschlossen.Bitte tun Sie dies.',
    endedStudyText:
      'Diese Zeichenfolge enthält Informationen zum Ende der Studie für den Benutzer.',
    nextOne:
      'Dieser Text wird angezeigt, um zu kommunizieren, wenn der nächste Fragebogen verfügbar ist: ',
    noQuestionnaireText:
      'Beim Laden des Fragebogens trat ein Fehler auf - bitte versuchen Sie es erneut.',
    noNewQuestionnaireAvailableYet:
      'Aktuell ist kein Fragebogen für Sie verfügbar.',
    nextOneNew:
      'Aktuell ist kein Fragebogen für Sie verfügbar. Der nächste Fragebogen wird am folgenden Tag für Sie verfügbar gemacht: ',
    noFurtherQuestionnaires:
      'Aktuell stehen keine weiteren Fragebögen für Sie zur Verfügung.',
    furtherInfo:
      'Wir informieren Sie, sobald ein weiterer Fragebogen verfügbar wird.',
    welcomeTextUser:
      'Eine Umfrage ist aktuell für Sie zum Ausfüllen verfügbar. Bitte beantworten Sie die Fragen bis zum angegebenen Zeitpunkt aus:',
    welcomeTextFirstTimeUser1:
      'Wir informieren Sie, sobald ein weiterer Fragebogen verfügbar wird. ',
    invalidInteger: 'Nur ganzzahlige Werte erlaubt!',
    invalidDecimal: 'Keine gültige Dezimalzahl!',
    invalidTooBig: 'Wert muss kleiner sein als:',
    invalidTooSmall: 'Wert muss größer sein als:',
    invalidNotEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    notMatchingPattern: 'Eingabe entspricht nicht den Vorgaben!',
    tapHereToStart: 'Tippen Sie hier, um mit dem Ausfüllen zu beginnen.',
    tapOnTitleToStart: 'Tippen Sie auf einen Fragebogen-Titel, um mit dem Beantworten des Fragebogens zu beginnen.',
    overviewOfSurveysHint: 'Sie können sich eine Übersicht der Fragebogeninhalte verschaffen, indem Sie auf den Pfeil rechts vom Titel des jeweiligen Fragebogens tippen.',
    notCompletedYet: 'Bislang nicht ausgefüllt',
    lastCompletedOn: 'Zuletzt ausgefüllt am',
    completeNow: 'Bitte jetzt ausfüllen',
    cancelAnswering: 'Beantwortung abbrechen',
    cancelAnsweringDescription: 'Möchten Sie die Beantwortung des aktuellen Fragebogens wirklich abbrechen?\n' +
        'Ihre bisherigen Antworten werden zwischengespeichert und Sie gelangen zurück zur Übersichtsseite.',
    closeQuestionnaire: 'Fragebogen schließen',
    continueAnswering: 'Beantwortung fortsetzen',
    continueSurvey: 'Mit der weiteren Befragung fortfahren',
    thanksSurvey: 'Vielen Dank!',

    completedTitle: 'Alle Fragen beantwortet',
    completedMessage: 'Sie haben alle verfügbare Fragen beantwortet, und können den Fragebogen nun abschicken.',

    expired: 'Die Studie ist abgelaufen. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an Ihre zuständige Ansprechperson.',

    finishedAllTitle: 'Vielen Dank für die Teilnahme!',
    finishedAllCloseHint: 'Sie können diese Seite nun schließen.',

    sliderInputNoSelectionMade: 'Sie haben noch keine Auswahl getätigt.',
    sliderInputNoSelectionMakeSelection1: 'Tätigen Sie Ihre Auswahl auf der schwarzen Linie, indem Sie an entsprechender Stelle der Linie ',
    sliderInputNoSelectionMakeSelection2: '',
    sliderInputNoSelectionMakeSelectionTap: 'tippen',
    sliderInputNoSelectionMakeSelectionClick: 'klicken',
    sliderInputYourSelection: 'Ihre Auswahl',
    sliderInputCancelSelection: 'Auswahl aufheben',
    sliderInputNoSelectionWantedHint1: 'Sie möchten keine Angabe machen. Falls Sie dennoch eine Angabe machen möchten, tätigen Sie Ihre Auswahl auf dem schwarzen Linie, indem Sie an entsprechender Stelle der Linie ',
    sliderInputNoSelectionWantedHint2: '',
    sliderInputNoSelectionWanted: 'Ich möchte keine Angabe machen',

    sketchUndo: 'Rückgängig',
    sketchClear: 'Löschen',
    sketchEraser: 'Radierer',
  },

  /** strings for the special-report-flow */
  reporting: {
    symptoms_no: 'NEIN',
    symptoms_yes: 'JAWOHL',
    symptoms_success_ok: 'Erfolgsbestätigung',
    symptoms_success_header: 'Erfolgs-Nachrichten-Header',
    symptoms_header: 'Sonderbericht schicken',
    symptoms_success_message: 'Erfolgsnachricht-Inhalt',
    symptoms_question: 'Bestätigungsfrage hier einfügen',
  },

  privacyPolicy: {
    title: 'Datenschutzerklärung',
    subTitle: '',
    content:
      'Diese App wird Ihnen vom Universitätsklinikum Bonn AöR, Venusberg-Campus 1, 53127 Bonn (nachfolgend "wir" oder „uns“) zur Verfügung gestellt. Bei der Nutzung dieser App werden von uns unter Umständen auch personenbezogene Daten erhoben, verarbeitet und genutzt. Weil uns der Schutz Ihrer Privatsphäre bei der Nutzung der App wichtig ist, möchten wir Sie mit den nachfolgenden Informationen darüber informieren, welche Ihrer personenbezogenen Daten erhoben werden, wenn Sie die App nutzen und wie wir mit diesen Daten umgehen. Sie können diese Datenschutzerklärung jederzeit unter <privacy_url>{{privacy_url}}</privacy_url> abrufen. Viele rechtliche Grundlagen für unsere Datenverarbeitung finden sich in der europäischen Datenschutzgrundverordnung (DSGVO), deren Text und die zugehörigen Erwägungsgründe die Sie z.B. <dsgvo_ch_1>hier</dsgvo_ch_1> finden können. In den nachfolgenden Hinweisen verweisen wir auf entsprechende Vorschriften als jeweilige Rechtsgrundlage unserer Verarbeitung.\n\n' +
      '<header>1. Verantwortliche Stelle/Kontakt, Beschwerden</header>\n\n' +
      'Verantwortliche Stelle im Sinne der Datenschutzgesetze (vgl. Art. 4 Nr. 7 DSGVO) ist das Universitätsklinikum Bonn AöR, Venusberg-Campus 1, 53127 Bonn. Sollten Sie Fragen oder Anregungen zum Datenschutz haben, können Sie sich per E-Mail an datenschutz@ukbonn.de wenden. Sie haben zudem, wenn wir Ihr Anliegen aus Ihrer Sicht nicht angemessen behandeln u.a. (Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs) ein Beschwerderecht bei der für den Datenschutz zuständigen Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.\n\n' +
      'Verantwortlicher für die Datenverarbeitung in Rahmen der Nutzung dieser App ist das\n\n' +
      'Universitätsklinikum Bonn (AöR)\n' +
      'Venusberg-Campus 1\n' +
      '53127 Bonn\n' +
      'E-Mail: researchdata@ukbonn.de\n\n'+
      'Datenschutzbeauftragter\n' +
      'Achim Flender\n' +
      'E-Mail: datenschutz@ukbonn.de\n\n' +
      'Wir sind Verantwortliche im Sinne der Datenschutzgesetze (vgl. Art. 4 Nr. 7 DSGVO). Sollten Sie Fragen zum Datenschutz haben, können Sie sich über die oben genannten Kontaktmöglichkeiten direkt an uns wenden.  Sie haben zudem, wenn wir Ihr Anliegen aus Ihrer Sicht nicht angemessen behandeln, u.a. (Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs) ein Beschwerderecht bei der für den Datenschutz zuständigen Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.\n\n' +
      '<header>2. Gegenstand des Datenschutzes</header>\n\n' +
      'Gegenstand des Datenschutzes sind personenbezogene Daten. Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person (im Folgenden „betroffene Person“) beziehen. Für die Identifizierbarkeit ist nicht unbedingt eine Namensangabe erforderlich. Es reicht auch eine indirekte Identifizierbarkeit aus, z.B. mittels Zuordnung zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen. Es geht also um Ihre Identität. Hierunter fallen beispielsweise Ihr Name, aber auch Ihre Telefonnummer, Ihre Anschrift, sowie andere Daten, die Sie uns mitteilen\n\n' +
      '<header>3. Art und Umfang der erhobenen Daten</header>\n\n' +
      '<subheader>Umfragedaten</subheader>\n' +
      'Im Rahmen der Nutzung der App nehmen Sie an Umfragen im Rahmen von klinischen oder sonstigen wissenschaftlichen Studien, Umfragen zu Qualitätsverbesserungsmaßnahmen oder sonstigen administrativen Umfragen teil. Einer Teilnahme setzt stets eine Einladung von der jeweiligen Studienkoordination voraus, bzw. von dem/der jeweiligen Autor:in der Umfrage. Dabei werden folgende Kategorien von Daten verarbeitet:\n\n' +
      '<item><strong>Inhaltliche Angaben:</strong> Wir erfassen die Antworten, die Sie aktiv in die bereitgestellten Formulare eingeben. Hierzu zählen insb. Daten über Ihren gesundheitlichen und psychischen Zustand, aktuelle Diagnosen, historische Diagnosnen, medizinische Vorgeschichte, und sonstige für die jeweilige Studie relevanten Daten. Zur Erreichung der Forschungsziele erhebt die App ggf. Sensordaten. Dies umfasst</item>\n\n' +
      '<subitem><strong>geräteinterne Sensoren:</strong> (wie z.B. Beschleunigungssensor, Gyroskop, Schrittzähler) Ihres Smartphones, sowie,</subitem>\n\n'+
      '<subitem><strong>externe Sensoren (Wearables):</strong> Sofern Sie ein kompatibles Endgerät (z. B. Fitness-Tracker, Brustgurt) via Bluetooth verbinden, erhebt die App (z. B. Herzfrequenz, Herzratenvariabilität, Sauerstoffsättigung).</subitem>\n\n' +
      '<item><strong>Art der Erhebung:</strong> Die Umfragen erfolgen entweder anonymisiert, pseudonymisiert oder identifiziert, abhängig vom Zweck der Studie und der jeweiligen Umfrage. Hierüber werden Sie von der jeweiligen Studienleitung, bzw. dem/der Autor:in der Umfrage gesondert informiert.</item>\n\n'+
      '<item><strong>Zweck der Befragung:</strong> Die Verarbeitung dient, je nach Kontext, der wissenschaftlichen Forschung, der wissenschaftlichen Auswertung zur Verbesserung der Patientenversorgung am Universitätsklinikum Bonn, oder sonstigen Erkenntnisgewinnung.</item>\n\n' +
      'Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die Erreichung der Forschungszwecke erforderlich ist oder wie es die gesetzlichen Aufbewahrungsfristen vorsehen:\n\n' +
      '<item><strong>Studienbegleitende Daten:</strong> Personenbezogene Daten (z. B. Ihre Einwilligungserklärung) werden gemäß den berufsrechtlichen Vorschriften für Ärzte sowie den Leitlinien zur Sicherung guter wissenschaftlicher Praxis in der Regel für 10 Jahre nach Abschluss der Studie aufbewahrt. Gemäß dem Zweck der Befragung bzw. der wissenschaftlichen Studie kann die Speicherfrist hiervon abweichen, hierüber werden Sie gesondert informiert.</item>\n\n' +
      '<item><strong>Anonymisierte Daten:</strong> Sobald die Daten vollständig anonymisiert wurden (d. h. ein Rückschluss auf Ihre Person dauerhaft ausgeschlossen ist), unterliegen sie nicht mehr den Regelungen der DSGVO und können für unbegrenzte Zeit zu Forschungszwecken weiterverwendet werden.</item>\n\n' +
      '<item><strong>Widerruf:</strong> Im Falle eines Widerrufs Ihrer Einwilligung werden Ihre Daten umgehend gelöscht, sofern der Anonymisierungsprozess noch nicht abgeschlossen ist und keine gesetzlichen Aufbewahrungspflichten einer Löschung entgegenstehen.</item>\n\n' +
      '<subheader>Anonymisierte Datenerhebung</subheader>\n' +
      'Zum Schutz unserer IT-Systeme und anderer Nutzer speicher wir für 7 Tage ab der Nutzung Ihre IP-Adresse (Rechtsgrundlage Art. 6 Abs. 1 lit f DSGVO), um ggf. in Zusammenarbeit mit Behörden und unter Einschaltung von Gerichten Angriffen zu begegnen und diese verfolgen zu können.\n\n' +
      '<subheader>Datennutzung zur Leistungserbringung</subheader>\n\n' +
      '<subheader>Gesonderte Einwilligung</subheader>\n'+
      'Sie können Ihre Einwilligung zur Nutzung der Standortdaten jederzeit widerrufen, indem Sie den Zugriff der App auf Ihre Standortdaten in den Einstellungen der App oder Ihres Endgeräts deaktivieren. Dann können Sie jedoch die Ortungs- und Navigationsfunktion der App nicht mehr nutzen. Der Widerruf von Einwilligungen wirkt für die Zukunft. Die Rechtmäßigkeit der Datenverarbeitung in der Vergangenheit bleibt unberührt.\n\n' +
      '<subheader>Datennutzung Ihrer Rückmeldungen, Kontaktaufnahmen</subheader>\n'+
      'Wenn Sie uns Rückmeldungen zur App geben, etwa über Formulare innerhalb der App oder sonst Meldungen zur App übermitteln, speichern und nutzen wir diese Daten zur Verbesserung der App und ihrer Funktionen.\n Wenn wir in diesem Zusammenhang Ihren Namen und/oder Ihre E-Mail-Adresse erhalten oder deren Angabe erbitten, so nutzen wir diese allein zur Kommunikation mit Ihnen im Rahmen Ihres Anliegens.\n\n Nehmen Sie über unsere Kontaktmöglichkeiten (z.B. über E-Mail oder das Kontaktformular) Kontakt mit uns auf, speichern wir Ihren Namen und Ihre Kontaktdaten sowie Ihr Anliegen. Die Daten werden verwendet, um Ihr Anliegen zu bearbeiten und mit Ihnen zu kommunizieren. Sie können in allen Fällen statt Ihres Namens auch ein Pseudonym angeben, es sei denn der Name ist für die Erledigung Ihres Anliegens notwendig. Hat sich Ihr Anliegen endgültig erledigt und bestehen keine sonstigen Aufbewahrungspflichten, werden die Daten wieder gelöscht. Rechtsgrundlage für die entsprechenden Datennutzungen ist Art. 6 Abs. 1 Satz 1 lit b DSGVO. Die Kommunikation über das Feedback-Formular erfolgt verschlüsselt.\n\n' +
      '<header>4. Push-Notifications</header>\n\n'+
      'Sie können uns die Erlaubnis erteilen, sog. Push-Notifications, also Mitteilungen auf Ihrem Gerät anzuzeigen. Hierbei kann es sich um Angebote, spezielle Erinnerungen oder sonstige Hinweise handeln. Wenn wir diese Funktion anbieten, werden wir Sie nach Ihrer Erlaubnis fragen. Sie können auch nach Erlaubniserteilung die Push-Notifications jederzeit in den Geräteeinstellungen deaktivieren. Die Rechtsgrundlage für diese Datenverarbeitung ist Ihre Einwilligung gem. Art. 6 Abs. 1 Satz 1 lit. a DSGVO.\n\n' +
      '<header>5. Datensicherheit</header>\n\n'+
      'Wir verschlüsseln den Datenaustausch zwischen der App und unseren Systemen während der Nutzung per TLS.\n\n' +
      '<header>6. Deinstallation und Löschung von Daten</header>\n\n'+
      'Wir speichern keine Daten zu Ihrer Person oder zu einem für uns auf Ihre Person rückführbaren Kennzeichen mit Ausnahme der von Ihnen veranlassten Kontaktanfragen (vgl. oben „Datennutzung Ihrer Rückmeldungen, Kontaktaufnahmen“ dort zur Löschung). Beachten Sie bitte, dass eine Deinstallation der App auf Ihrem Gerät nicht automatisch zur Löschung Ihrer personenbezogenen Daten aus Ihren Anfragen auf unserem Server führt. Sie können Ihre Daten aber jederzeit löschen lassen, indem Sie Ihren Nutzungsvertrag mit uns kündigen.\n\n' +
      '<header>7. Ihre Rechte</header>\n\n'+
      'Sie haben das Recht auf Auskunft (inklusive unentgeltlicher Überlassung einer Kopie) über Ihre, im Rahmen der Studie erhoben und verarbeitet personenbezogenen Daten. Außerdem können Sie die Berichtigung unzutreffender Daten, die Löschung oder die Einschränkung der Verarbeitung Ihrer Daten verlangen.\n\n'+
      '<strong>Sie können Ihre Einwilligung jederzeit widerrufen ohne dass Ihnen dadurch Nachteile entstehen.</strong> Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der, aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.\n\n' +
      '<header>8. Kontaktdaten des Datenschutzbeauftragten</header>\n\n'+
      'Achim Flender\n'+
      'Universitätsklinikum Bonn - Anstalt des öffentlichen Rechts\n'+
      'Venusberg-Campus 1\n'+
      '53127 Bonn\n\n'+
      'E-Mail: datenschutz@ukbonn.de\n'+
      'Telefon: 0228 – 287 160 75\n\n' +
      '<header>9. Beschwerderecht bei der Aufsichtsbehörde:</header>\n\n'+
      'Sie haben jederzeit das Recht, sich an die zuständige Aufsichtsbehörde zu wenden:\n\n'+
      'Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen\n'+
      'Kavalleriestr. 2-4, 40213 Düsseldorf\n'+
      'E-Mail: poststelle@ldi.nrw.de, Telefon: 0211 – 384 24-0\n\n' +
      '<header>10. Änderungen dieser Datenschutzerklärung</header>\n\n'+
      'Wir halten diese Datenschutzerklärung immer auf dem neuesten Stand. Deshalb behalten wir uns vor, sie von Zeit zu Zeit zu ändern und Änderungen bei der Erhebung, Verarbeitung oder Nutzung Deiner Daten nachzupflegen. Die aktuelle Fassung der Datenschutzerklärung ist stets unter <privacy_url>{{privacy_url}}</privacy_url> abrufbar. \n\n'+
      'Stand: Juni 2026 ',
  },

  dateTimePicker: {
    time: 'Uhr',
    hour: 'Std.',
    minute: 'Min.',
    second: 'Sek.',
    sum_max: 'Die aufaddierte Eingabe darf höchstens {{max}} sein.\n',
    sum_min: 'Die aufaddierte Eingabe muss mindestens {{min}} sein.\n',
    max: 'Die Eingabe darf höchstens {{max}} sein.\n',
    min: 'Die Eingabe muss mindestens {{min}} sein.\n',
    months: ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
    select_date: 'Bitte Auswahl tätigen',
    pick_date: 'Datum auswählen'
  },

  /** each entry in this array will generate a new listItem on the about-screen. When clicked on such an item, a webView will open that
   * can display any website. "iconType" is the name of a free Webfont and the title is the name of the particular icon. .
   * as this app is using react-native-elements, the list of compatible fonts can be found in its documentation: * https://reactnativeelements.com/docs/icon
   */
  webViews: [
    {
      title: 'Impressum',
      subTitle:
          ' ',
      screenSubTitle: '',
      uri: 'https://www.ukbonn.de/impressum/',
      iconTitle: 'info',
      iconType: 'entypo',
    },
    {
      title: 'Datenschutzerklärung',
      subTitle:
        ' ',
      screenSubTitle: '',
      uri: 'Privacy',
      iconTitle: 'suitcase',
      iconType: 'entypo',
    },
    {
      title: 'Nutzungsbedingungen',
      subTitle:
        ' ',
      screenSubTitle: '',
      uri: 'Terms',
      iconTitle: 'suitcase',
      iconType: 'entypo',
    },
  ],

  /** each entry in this array will generate a new listItem on the about-screen. When clicked on such an item, a modal will open
   * that informs the user that he/she is being redirected to their local browser. "iconType" is the name of a free Webfont and the title is the name of the particular icon. .
   * as this app is using react-native-elements, the list of compatible fonts can be found in its documentation: * https://reactnativeelements.com/docs/icon
   */
  modalLinks: [
    // {
    //   title: 'Erster Link',
    //   subTitle:
    //     'Dies ist ein regulärer Link.Es wird ein Modal eröffnet, bevor der Benutzer den Benutzer auf seinen eigenen Browser umleitet.',
    //   text: 'Ihre werden jetzt umgeleitet.',
    //   uri: 'https://github.blog/',
    //   iconTitle: 'link',
    //   iconType: 'entypo',
    // },
    // {
    //   title: 'Zweiter Link',
    //   subTitle:
    //     'Für jeden Artikel fügen Sie der Eigenschaft Modulks von textconfig.js hinzu, ein anderer Eintrag in dieser Liste wird generiert.',
    //   text: 'Ihre werden jetzt umgeleitet.',
    //   uri: 'https://ibm.com/',
    //   iconTitle: 'link',
    //   iconType: 'entypo',
    // },
  ],
};
